module.exports = __webpack_public_path__ + "media/react/features/integration/assets/app-store-banner-77474880161b449b124e4fdf6a2f6785.png";